import React, { Component, PropTypes } from 'react';

import Contracts from '../lr_dlr_components/Contracts';
import Courseworkcomp from '../lr_dlr_components/Courseworkcomp';
import Practiceassigment from '../lr_dlr_components/Practiceassigment';
import ContextQuestionnaire from '../lr_dlr_components/ContextQuestionnaire';
import FeedbackForm from '../lr_dlr_components/FeedbackForm';
import Webcastlive from '../lr_dlr_components/Webcastlive';
import EvaluationForm from '../lr_dlr_components/EvaluationForm';
import Thanks from '../lr_dlr_components/Thanks';
import Descriptivetask3 from '../lr_dlr_components/Descriptivetask3';
import GridComp from '../lr_dlr_components/GridComp';
import Testresults from '../lr_dlr_components/Testresults';
import Ctestonebyone from '../lr_dlr_components/Ctestonebyone';
import * as Config from '../config/Config';
import * as User from '../helpers/User';
import * as Common from '../helpers/Common';

const styles={
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    float: 'left',
    width: '100%',
    position: 'absolute',
    height: '100%'
};

class RoomCompLayout extends Component {

    constructor(props) {
        super(props);      

        this.state={
            
            compBlock:null
        };

       
    }


    emptyFunc(){

    }

    noAuthorizedPage(){
        return <div style={styles}>You are not authorized to access this page!"</div>;
    }


    getComponent(){

        Common.reactLoader("show", "Please wait...");
        let params=this.props.params;
        let data=JSON.stringify({
            learner_id:User.UserId(),
            room_id:params.room_id,
            dlr_id:params.dlr_id,
            compseq_id:params.compseq_id
          });

        fetch(Config.domainUrl + 'mobile/component/view', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body:data
        }).then((response) => response.json()).then((responseJson) => {
            if (responseJson.status == 2) {  

                let component=null;
                let data=responseJson.lrcomponents[params.divider_id][0];
             
                switch (data.compo_type) {
                    case "contract":
                        component = <Contracts data={data} usableType="mobileapp" switchback={()=>this.emptyFunc()} returnthanks={()=>this.emptyFunc()}/>;
                        break;                  
                    case "coursework":
                        component = <Courseworkcomp data={data} usableType="mobileapp" switchback={()=>this.emptyFunc()} returnthanks={()=>this.emptyFunc()}/>;
                        break;
                    case "practice":
                        component = <Practiceassigment data={data} usableType="mobileapp" switchback={()=>this.emptyFunc()} returnthanks={()=>this.emptyFunc()}/>;
                        break;
                    case "descriptivetask":
                        component = <Descriptivetask3 data={data} usableType="mobileapp" switchback={()=>this.emptyFunc()} returnthanks={()=>this.emptyFunc()}/>;
                        break;
                    case "context":
                        component = <ContextQuestionnaire data={data} usableType="mobileapp" switchback={()=>this.emptyFunc()} returnthanks={()=>this.emptyFunc()}/>;
                        break;
                    case "feedbackform":
                        component = <FeedbackForm data={data} usableType="mobileapp" switchback={()=>this.emptyFunc()} returnthanks={()=>this.emptyFunc()}/>;
                        break;                    
                    case "webcastlive":
                        component = <Webcastlive data={data} usableType="mobileapp" switchback={()=>this.emptyFunc()} returnthanks={()=>this.emptyFunc()}/>;
                        break;
                    case "evaluation":
                        component = <EvaluationForm data={data} usableType="mobileapp" switchback={()=>this.emptyFunc()} returnthanks={()=>this.emptyFunc()}/>;
                        break;                   
                    case "girdcomponent":
                        component = <GridComp data={data} usableType="mobileapp" switchback={()=>this.emptyFunc()} returnthanks={()=>this.emptyFunc()} />;
                        break;                   
                    case "ctestonebyone":
                        component = <Ctestonebyone data={data} usableType="mobileapp" switchback={()=>this.emptyFunc()} returnthanks={()=>this.emptyFunc()} />;                        
                        break;
                    case "testresults":
                        component = <Testresults data={data} usableType="mobileapp" switchback={()=>this.emptyFunc()} returnthanks={()=>this.emptyFunc()} />;                        
                        break;
                    case "thanks":
                        component = <Thanks data={data} usableType="mobileapp" switchback={()=>this.emptyFunc()} />                    
                         break;
                    default:
                        component =this.noAuthorizedPage()
        
                }
            

                this.setState({
                    compBlock:component
                })

            }
            
            Common.reactLoader("hide");
        });

    }

    
    componentDidMount () {

        Common.reactLoader("show", "Please wait...");

        let query_data=Common.objToSlashString({

            app_code:this.props.params.app_code,
            device_id:this.props.params.device_id
           });

        fetch(Config.domainUrl + 'mobile/learner/check' +query_data, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then((response) => response.json()).then((responseJson) => {
            if (responseJson.status == 1) {

              
                Common.setTokenData("token", responseJson.data.token);
            

             this.getComponent();

            }else{
              
                this.setState({
                    compBlock:this.noAuthorizedPage()
                })
            }
            
            Common.reactLoader("hide");
        });

    }

    render () {
        return (
            <div>
                {this.state.compBlock}
            </div>
        )
    }
}

export default RoomCompLayout;




// WEBPACK FOOTER //
// ./src/layouts/RoomCompLayout.js